import React from 'react';
import ReactDOM from 'react-dom/client';
import LocalizedStrings from "react-localization";

let strings = new LocalizedStrings({
    ru: {
        free_class: "Приходите на бесплатное занятие",
        title: "Приходите на занятия",
        leave_contacts: "Оставьте контакты и мы вам перезвоним.",
        phone: "Телефон",
        phone_number: "Номер телефона",
        email: "Электронная почта",
        name: "Имя",
        your_name: "Ваше имя",
        your_comment: "Ваш комментарий",
        comment: "Комментарий",
        subscribe: "Подписаться на рассылку",
        submit: "Отправить",
        by_clicking: 'Нажимая "Отправить", Вы подтверждаете',
        personal_data: 'условия обработки персональных данных',
        and: 'и',
        refund_terms: 'условия пользования/возврата',
        phone_or_email: 'Пожалуйста, укажите номер телефона или электронную почту.',
        try_again_later: 'Произошла ошибка. Пожалуйста, повторите позже или свяжитесь с нами.',
    },
    et: {
        free_class: "Tule tasuta tunnile",
        title: "Tule ujumistreeningule",
        leave_contacts: "Jäta oma kontaktid ja me helistame sulle tagasi.",
        phone: "Telefon",
        phone_number: "Telefoninumber",
        email: "E-post",
        name: "Nimi",
        your_name: "Sinu nimi",
        your_comment: "Sinu kommentaar",
        comment: "Kommentaar",
        subscribe: "Telli uudiskiri",
        submit: "Esita",
        by_clicking: 'Klõpsates "Esita", kinnitad',
        personal_data: 'isikuandmete töötlemise tingimused',
        and: 'ja',
        refund_terms: 'kasutus-/tagastustingimused',
        phone_or_email: 'Palun kirjutage oma telefoninumber või e-posti aadress.',
        try_again_later: 'Tekkis viga. Palun proovige hiljem uuesti või võtke meiega ühendust.',
    }
});
strings.setLanguage(localStorage.getItem('language'))

export class ContactForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            phone: '',
            email: '',
            name: '',
            comment: '',
            subscribe: false,
            validationError: '',
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePhoneChanged = this.handlePhoneChanged.bind(this);
        this.handleEmailChanged = this.handleEmailChanged.bind(this);
        this.handleNameChanged = this.handleNameChanged.bind(this);
        this.handleCommentChanged = this.handleCommentChanged.bind(this);
        this.handleSubscribeChanged = this.handleSubscribeChanged.bind(this);
    }

    handleSubmit() {
        if (this.state.phone === '' && this.state.email === '') {
            this.setState(() => ({
                validationError: strings.phone_or_email
            }));
        } else {
            fetch('/v2/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: this.state.email,
                    phone: this.state.phone,
                    name: this.state.name,
                    comment: this.state.comment,
                    subscribe: this.state.subscribe
                })
            }).then((response) => {
                if (response.ok) {
                    try {
                        gtag('event', 'application_applied', {
                            'event_category': 'first_train_registration',
                        });
                        fbq('trackCustom', 'ApplicationApplied');
                    } catch (e) {}

                    document.location.href = '/thanks';
                } else {
                    this.setState(() => ({
                        validationError: strings.try_again_later
                    }));
                }
            })
        }
    }

    handlePhoneChanged(event) {
        this.setState(() => ({
            phone: event.target.value,
            validationError: ''
        }));
    }
    handleEmailChanged(event) {
        this.setState(() => ({
            email: event.target.value,
            validationError: ''
        }));
    }
    handleNameChanged(event) {
        this.setState(() => ({
            name: event.target.value
        }));
    }
    handleCommentChanged(event) {
        this.setState(() => ({
            comment: event.target.value
        }));
    }
    handleSubscribeChanged() {
        this.setState(state => ({
            subscribe: !state.subscribe
        }));
    }

    render() {
        return <>
            <div className="w-10/12 mx-auto sm:w-[560px] lg:w-[620px] xl:w-[620px]">
                <div className="text-5xl font-semibold text-center">
                    { this.props.title }
                </div>
                <div className="text-2xl font-light mt-10 text-center">
                    { strings.leave_contacts }
                </div>

                { this.state.validationError !== '' && (
                    <div className="text-red-800 text-center">
                        { this.state.validationError }
                    </div>
                ) }

                <div className="mt-11">
                    <label htmlFor="contactPhone" className="block font-light">{ strings.phone }</label>
                    <input name="phone" id="contactPhone" placeholder={strings.phone_number}
                           className="block border border-black w-full px-3 py-2 focus:rounded-none h-[60px]"
                           value={this.state.phone} onChange={this.handlePhoneChanged}
                    />

                    <label htmlFor="contactEmail" className="block font-light mt-6">{ strings.email }</label>
                    <input name="email" id="contactEmail" placeholder={ strings.email }
                           className="block border border-black w-full px-3 py-2 focus:rounded-none h-[60px]"
                           value={this.state.email} onChange={this.handleEmailChanged}
                    />

                    <label htmlFor="contactName" className="block font-light mt-6">{ strings.name }</label>
                    <input name="name" id="contactName" placeholder={ strings.your_name }
                           className="block border border-black w-full px-3 py-2 focus:rounded-none h-[60px]"
                           value={this.state.name} onChange={this.handleNameChanged}
                    />

                    <label htmlFor="contactComment" className="block font-light mt-6">{ strings.your_comment }</label>
                    <input name="comment" id="contactComment" placeholder={ strings.comment }
                           className="block border border-black w-full px-3 py-2 focus:rounded-none h-[60px]"
                           value={this.state.comment} onChange={this.handleCommentChanged}
                    />

                    <div className="mt-6">
                         <input type="checkbox" name="subscribe" id="contactSubscribe" checked={this.state.subscribe} onChange={this.handleSubscribeChanged}/>
                         <label htmlFor="contactSubscribe" className="ml-3">{ strings.subscribe }</label>
                    </div>

                    <div className="mt-8 mb-2.5">
                         <button
                             className="mx-auto bg-[#2971f5] rounded-full text-white font-semibold px-16 py-5 block"
                             onClick={this.handleSubmit}
                         >
                             { strings.submit }
                         </button>
                    </div>

                    <div className="text-center font-light text-sm mt-8">
                        { strings.by_clicking }{' '}
                        <a href={"/police-cookies"} className="text-[#0077ff]">
                            { strings.personal_data }
                        </a>
                        {' '}{ strings.and }{' '}
                        <a href={"/privacy-terms"} className="text-[#0077ff]">
                            { strings.refund_terms }
                        </a>.
                    </div>
                </div>
            </div>
        </>;
    }
}

if (document.getElementById('contact_form')) {
    const root = ReactDOM.createRoot(document.getElementById('contact_form'));
    root.render(<ContactForm title={ strings.free_class }/>);
}

if (document.getElementById('individual_contact_form')) {
    const root = ReactDOM.createRoot(document.getElementById('individual_contact_form'));
    root.render(<ContactForm title={ strings.title }/>);
}
